import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Scale, AlertCircle } from 'lucide-react';
import { getBusinessCaseById } from '../../data/mockBusinessData';
import CaseHeader from '../../components/client/case/CaseHeader';
import CaseMainPanel from '../../components/client/case/CaseMainPanel';
import CaseSidebar from '../../components/client/case/CaseSidebar';

const BusinessCaseDetailsPage = () => {
  const { caseId } = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [caseData, setCaseData] = useState(null);
  const [activeSection, setActiveSection] = useState('overview');

  useEffect(() => {
    const data = getBusinessCaseById(caseId);
    if (data) {
      setCaseData(data);
    }
  }, [caseId]);

  if (!caseData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <AlertCircle className="w-20 h-20 text-gray-300 mx-auto mb-4" />
          <h1 className="text-2xl font-black text-gray-700 mb-2">القضية غير موجودة</h1>
          <p className="text-gray-500 mb-6">لم نتمكن من العثور على هذه القضية</p>
          <button
            onClick={() => navigate('/business/dashboard')}
            className="px-6 py-3 bg-[#1E3A8A] text-white rounded-lg hover:bg-[#C8A870] transition-colors font-bold"
          >
            العودة للوحة التحكم
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Back Button */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <button
            onClick={() => navigate('/business/dashboard')}
            className="flex items-center gap-2 text-gray-600 hover:text-[#1E3A8A] transition-colors font-bold"
          >
            <ArrowRight className="w-5 h-5" />
            <span>العودة إلى لوحة التحكم</span>
          </button>
        </div>
      </div>

      {/* Case Header */}
      <CaseHeader caseData={caseData} portalType="business" />

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar - 1/4 */}
          <div className="lg:col-span-1">
            <CaseSidebar 
              caseData={caseData}
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              portalType="business"
            />
          </div>

          {/* Main Panel - 3/4 */}
          <div className="lg:col-span-3">
            <CaseMainPanel 
              caseData={caseData}
              activeSection={activeSection}
              portalType="business"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCaseDetailsPage;
